import WebsiteElement from "./WebsiteElement";

export default class CoverBlock extends WebsiteElement {
    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
        super(element);

        /**
         * @type {number}
         */
        this.animateInTiming = 2000;
    }

    /**
     * @param {HTMLElement} element
     */
    static is(element) {
        return element.classList.contains('wp-block-cover');
    }
}